import { Skeleton } from '@mui/material';
import { NavbarSupport } from '@diana/core';
import { useFlowBuilder2PageContext } from '../../Context/useFlowBuilder2PageContext';

export const HelpIconButton = () => {
  const { isLoading: isLoadingPage, error: pageError } = useFlowBuilder2PageContext();

  if (isLoadingPage) return <Skeleton variant="circular" width={32} height={32} />;
  if (!pageError) return <NavbarSupport isFlowBuilder />;

  return null;
};
